import { useState } from 'react';

const projects = [
  {
    src: 'https://static.readdy.ai/image/2ea99eca8941bf5bf2c30db416911f3e/6648c072c88e382da1458dbc470624eb.jpeg',
    alt: 'Custom steel gate and canopy fabrication with privacy slat fencing for commercial property',
    title: 'Steel Gate & Canopy Fabrication',
    category: 'Custom Fabrication',
  },
  {
    src: 'https://static.readdy.ai/image/2ea99eca8941bf5bf2c30db416911f3e/b5e12f651b8ae99a0c59e0392c006970.jpeg',
    alt: 'Steel canopy structure with privacy slat fencing installed at commercial building entrance in California',
    title: 'Commercial Steel Canopy & Fencing',
    category: 'Structural Steel',
  },
  {
    src: 'https://static.readdy.ai/image/2ea99eca8941bf5bf2c30db416911f3e/1ad833a1fb999eb4ab9793a0e821a33e.jpeg',
    alt: 'Heavy equipment installing structural steel canopy beams at commercial construction site with forklift',
    title: 'Commercial Steel Canopy Installation',
    category: 'Structural Steel',
  },
  {
    src: 'https://static.readdy.ai/image/2ea99eca8941bf5bf2c30db416911f3e/0740a19ae2d7b10b1535536f3e75deb7.jpeg',
    alt: 'Custom fabricated steel staircase and ramp with safety railings built in professional welding shop',
    title: 'Steel Staircase & Ramp Fabrication',
    category: 'Custom Fabrication',
  },
  {
    src: 'https://static.readdy.ai/image/2ea99eca8941bf5bf2c30db416911f3e/a7c6d5d48f544bd64affe2af63c2ce12.jpeg',
    alt: 'Industrial steel staircase with grated treads fabricated in professional welding shop for commercial project',
    title: 'Industrial Steel Staircase',
    category: 'Custom Fabrication',
  },
];

export default function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % projects.length);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">Our Work</span>
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-4">
            PROJECT <span className="text-[#E8740C]">PORTFOLIO</span>
          </h2>
          <p className="text-[#4A4A4A] text-sm max-w-2xl mx-auto leading-relaxed font-body">
            See the quality of our structural steel welding, custom fabrication, and heavy equipment repair work — trusted by contractors across California.
          </p>
        </div>

        <div className="relative">
          <div className="w-full h-[520px] overflow-hidden rounded-lg relative group">
            <img
              src={projects[currentIndex].src}
              alt={projects[currentIndex].alt}
              title={projects[currentIndex].title}
              className="w-full h-full object-cover object-center transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block bg-[#E8740C] text-white text-xs font-heading font-bold tracking-wider px-3 py-1 rounded mb-3">
                {projects[currentIndex].category}
              </span>
              <h3 className="text-white font-heading font-bold text-xl">{projects[currentIndex].title}</h3>
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-[#1A1A1A]/80 hover:bg-[#E8740C] text-white w-12 h-12 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            aria-label="Previous project"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-[#1A1A1A]/80 hover:bg-[#E8740C] text-white w-12 h-12 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            aria-label="Next project"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex justify-center gap-2 mt-6">
            {projects.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  idx === currentIndex ? 'bg-[#E8740C]' : 'bg-[#D4D4D4] hover:bg-[#E8740C]/50'
                }`}
                aria-label={`Go to project ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
